import React from 'react';
import './PageSubtitle.scss';
import classnames from 'classnames';

interface PageSubtitleProps {
  title: string;
  description?: string;
  removeBottom?: boolean;
}
export default function PageSubtitle({ title, description, removeBottom }: PageSubtitleProps): React.ReactElement {
  return (
    <section className={classnames('page-subtitle', { 'page-subtitle__remove-bottom': removeBottom })}>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </section>
  );
}
